import { Typography, styled } from "@mui/material";

const StyledLabel = styled(Typography)(({ theme }) => ({
  fontWeight: "700",
  paddingBottom: ".3rem",
  color: "#000000",
}));

export { StyledLabel };
